export default {
  // component: null,
  priority: 600,
  permissions: [
    "FeedingConsoleMenu",
    "6b5e06b5e056ff933a8d12d37b795352c91a349d090633df5d1ccc0bdfc53589e55df56ff933a8d12d37b795352c91a349d090633df5d1ccc0bdfc53589e55df",
  ], //['FoodMenu','FoodMealMenu', 'SelfServiceMenu', 'FoodProgramMenu', 'UserPaymentCheckPrintMenu', 'FoodDeviceMenu', 'ReportFoodProgramMenu',
  // 'ReportGeneralReportMenu', 'ReportOrderMenu'], // TODO
  name: app.translate("routes.home.feed.Feed"),
  icon: "food-fork-drink",
  drawer: true,
  path: "feed",
  description: `کنسول تغذیه: در این ماژول شما میتوانید انواع غذاهای مورد نظر، زمان ارائه وعده های غذایی،‌ سلف و برنامه غذایی سازمان خود را مشخص نمایید که بر اساس آن پرسنل بتوانند همانند فرایند درخواست مرخصی و ماموریت اقدام به ثبت رزرو غذا نمایند و پس از آن می توانید آمار دقیقی از تعداد و نوع غذاهایی که باید ارائه شود داشته باشید.
لازم به ذکر است هدف این ماژول صرفا ارائه آمار تعدادی رزروهای انجام شده می باشد و هزینه غذاها و کسر آن از پرسنل و ... در آن لحاظ نشده است.`,
};
